<template>
  <a-modal :title="title" :width="520" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="档口名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入档口名称' }] }]" placeholder="如：热菜档 / 凉菜档 / 主食档" />
      </a-form-item>
      <a-form-item label="厨房联打印机" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-decorator="['printerId']" placeholder="选择打印机（留空则该档口不出厨房联）" allow-clear>
          <a-select-option v-for="p in printers" :key="p.id" :value="p.id">{{ p.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="拆单粒度" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-radio-group v-decorator="['granularity', { initialValue: 'per_order' }]">
          <a-radio value="per_order">整单（按档口拆，每单一票）</a-radio>
          <a-radio value="per_item">单菜（每菜一票）</a-radio>
          <a-radio value="per_category">分类（按菜品分类一票）</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="同款合并" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-switch v-decorator="['mergeSame', { valuePropName: 'checked', initialValue: true }]" />
        <span style="margin-left:8px;color:#999">同一单内同菜品+同做法合并数量</span>
      </a-form-item>
      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-number v-decorator="['sort', { initialValue: 0 }]" :min="0" :max="999" style="width:120px" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { stationCreate, stationUpdate } from '@/api/plugin/dining'

export default {
  name: 'DiningStationModal',
  props: ['storeId', 'printers'],
  data() {
    return {
      title: '',
      visible: false,
      confirmLoading: false,
      editId: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 17, offset: 1 },
      form: this.$form.createForm(this)
    }
  },
  methods: {
    add() {
      this.editId = null
      this.title = '新增档口'
      this.visible = true
      this.$nextTick(() => this.form.resetFields())
    },
    edit(record) {
      this.editId = record.id
      this.title = '编辑档口'
      this.visible = true
      this.$nextTick(() => this.form.setFieldsValue({
        name: record.name,
        printerId: record.printer_id || undefined,
        granularity: record.granularity || 'per_order',
        mergeSame: String(record.merge_same) === '1',
        sort: record.sort || 0
      }))
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) return
        const data = {
          storeId: this.storeId,
          name: values.name,
          printerId: values.printerId || null,
          granularity: values.granularity,
          mergeSame: values.mergeSame ? '1' : '0',
          sort: values.sort || 0
        }
        this.confirmLoading = true
        const req = this.editId ? stationUpdate(this.editId, data) : stationCreate(data)
        req.then(res => {
          this.confirmLoading = false
          if (res.code === 200) {
            this.$message.success(res.message || '保存成功')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        }).catch(() => { this.confirmLoading = false })
      })
    },
    handleCancel() { this.visible = false }
  }
}
</script>
